import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function LeadershipTeam() {
  const team = [{
    name: 'Simeon Praymond',
    role: 'Founder & Executive Placement Specialist',
    bio: 'With over 23 years at the intersection of ambition and opportunity, Simeon has dedicated his career to ensuring that the executives who drive our economy never navigate their most critical career pivots alone.',
    initials: 'SP',
    image: 'https://cdn.magicpatterns.com/uploads/sQGDZ1iyxWCQQNdUnYyAfx/WhatsApp_Image_2026-02-17_at_23.50.44.jpg'
  }, {
    name: 'Aaron Joshua',
    role: 'Director of Talent Acquisition',
    bio: 'As Director of Talent Acquisition at Boardline, Aaron leads the strategic identification and engagement of top-tier executive talent, ensuring every placement is the right fit for both the candidate and the organization.',
    initials: 'AJ'
  }, {
    name: 'Caleb Logan',
    role: 'Executive Human Resources Specialist',
    bio: 'With over 10 years of specialized experience in executive human resources, Caleb brings deep expertise in talent strategy, organizational leadership, and C-suite advisory to every client engagement.',
    initials: 'CL',
    image: 'https://cdn.magicpatterns.com/uploads/qZ4dbGSADnRvKSewgjU4JS/WhatsApp_Image_2026-02-18_at_00.06.11.jpg'
  }, {
    name: 'Prescott Grant',
    role: 'Executive Search & Leadership Advisory',
    bio: 'With 7 years of experience partnering with organizations on confidential senior and executive mandates, Prescott works selectively with proven leaders to align strategic impact, leadership fit, and long-term organizational outcomes.',
    initials: 'PG',
    image: 'https://cdn.magicpatterns.com/uploads/a4QMbgDu2JbS53iJS1zies/WhatsApp_Image_2026-02-18_at_00.jpg'
  }];
  return <Section background="white" id="team" data-id="element-292">
      <FadeIn className="mb-16 text-center" data-id="element-293">
        <h2 className="text-3xl md:text-4xl font-serif text-ink-900 mb-4" data-id="element-294">
          Leadership Team
        </h2>
        <div className="h-[1px] w-24 bg-accent-400 mx-auto" data-id="element-295" />
      </FadeIn>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-296">
        {team.map((member, index) => <FadeIn key={index} delay={index * 0.1} className="group" data-id="element-297">
            <div className="flex flex-col items-center text-center p-5 md:p-6 bg-white rounded-sm hover:shadow-lg transition-all duration-300 border border-sage-200 hover:border-accent-400/40 h-full" data-id="element-298">
              {member.image ? <div className="mb-6 p-[3px] rounded-md bg-gradient-to-br from-amber-400 via-rose-500 to-violet-600 group-hover:from-amber-300 group-hover:via-rose-400 group-hover:to-violet-500 transition-all duration-300 group-hover:scale-105" data-id="element-299">
                  <div className="w-36 h-48 md:w-40 md:h-52 rounded-[5px] overflow-hidden" data-id="element-300">
                    <img src={member.image} alt={member.name} className="w-full h-full object-cover object-top" data-id="element-301" />
                  </div>
                </div> : <div className="w-36 h-48 md:w-40 md:h-52 rounded-md bg-ink-900 flex items-center justify-center mb-6 border-2 border-accent-400/50 group-hover:border-accent-400 group-hover:scale-105 transition-all duration-300" data-id="element-302">
                  <span className="font-serif text-3xl text-accent-400" data-id="element-303">
                    {member.initials}
                  </span>
                </div>}
              <h3 className="text-lg font-serif font-bold text-ink-900 mb-2" data-id="element-304">
                {member.name}
              </h3>
              <p className="text-xs uppercase tracking-widest text-accent-500 mb-4 min-h-[2rem]" data-id="element-305">
                {member.role}
              </p>
              <p className="text-sm text-body leading-relaxed" data-id="element-306">{member.bio}</p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}